import { render } from "./AdvertisingCampaign.vue?vue&type=template&id=417e2dc0&scoped=true"
import script from "./AdvertisingCampaign.vue?vue&type=script&lang=js"
export * from "./AdvertisingCampaign.vue?vue&type=script&lang=js"

import "./AdvertisingCampaign.vue?vue&type=style&index=0&id=417e2dc0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Cesar\\Documents\\Proyectos\\POSVitialife\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417e2dc0"]])

export default __exports__